import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { ShipperResponse } from 'src/pages/shippers/details/information/types';
import { NoContent } from 'src/utils/no-content';
import urlTemplate from 'url-template';

type HookConfig = {
  shipperUrl: string;
  shipperUuid: string;
};

export function useContractManagementShipper({
  shipperUrl,
  shipperUuid,
}: HookConfig) {
  const shipper = useAxios(
    (axios, signal) => {
      const url = urlTemplate
        .parse(shipperUrl)
        .expand({ shipperId: shipperUuid });

      return axios.request<ShipperResponse | NoContent>({
        signal,
        url,
        validateStatus: (status) => status === 200 || status === 404,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    shipper.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shipper;
}

export type ContractManagementShipperRequest = ReturnType<
  typeof useContractManagementShipper
>;
